// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"32465db5","802":"b5d75b1c","885":"e3176469"}[chunkId] + ".chunk.js";
};